import { createLucideIcon } from 'lucide-react';
export const StickyNoteIcon = createLucideIcon('sticky-note', [
  [
    'path',
    {
      d: 'M16.25 19.5H3.5V4.5H20.5V16L16.25 19.5Z',
      key: '1i0eg7',
    },
  ],
  [
    'path',
    {
      d: 'M20 15.5H16V19',
      key: '1ifbyk',
    },
  ],
]);
